import React from 'react';
import PropTypes from 'prop-types';
import { classes } from '../../Tabs.st.css';

var SideContent = function SideContent(_ref) {
  var content = _ref.content;
  return content ? /*#__PURE__*/React.createElement("div", {
    "data-content": "true",
    className: classes.sideContent
  }, content) : null;
};

SideContent.propTypes = {
  content: PropTypes.node
};
export default SideContent;